import { render } from "./DashboardItem.vue?vue&type=template&id=46fa4a61&scoped=true"
import script from "./DashboardItem.vue?vue&type=script&lang=js"
export * from "./DashboardItem.vue?vue&type=script&lang=js"

import "./DashboardItem.vue?vue&type=style&index=0&id=46fa4a61&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fa4a61"]])

export default __exports__